export enum Locale {
  EN = "en",
  ZH_CN = "zh",
}

// 标准的语言枚举
export enum standardLocale {
  EN = "en",
  ZH_CN = "zh-CN",
}

// URl输入的标准语言和系统i18n的对照关系
export enum UrlLangguageLocale {
  "en" = Locale.EN,
  "zh-CN" = Locale.ZH_CN,
}

// 系统i18n和标准语言的对照关系
export enum ArticleLocale {
  "en" = standardLocale.EN,
  "zh" = standardLocale.ZH_CN,
}
